import ActiveApplication from '../schemas/applications/ActiveApplication';

const filterApplicationChangeOrders = (application: ActiveApplication): void => {
  if (application?.project?.projectLines) {
    application.applicationLines = application.applicationLines.filter(
      // Bring it in if we have an original project line
      line => line.projectLine && line.projectLine.lineType === 'original' || (
        // Or we have a change order with a firstApplicationSequence number that
        // matches the current or a prior application
        line.projectLine
        && line.projectLine.lineType === 'changeOrder'
        && application.sequenceNumber
        && line.projectLine.firstApplicationSequenceNumber && (
          line.projectLine.firstApplicationSequenceNumber <= application.sequenceNumber
        )
      )
    );
    
    // Update the change order lines using the filtered application lines
    application.changeOrderLines = application.applicationLines.filter(line => line?.projectLine?.lineType === 'changeOrder');

    // Get original lines
const originalLines = application.applicationLines.filter(
  line => line?.projectLine?.lineType === 'original'
);

// Get change order lines
application.changeOrderLines = application.applicationLines
  .filter(line => line?.projectLine?.lineType === 'changeOrder')
  .map(coLine => {
    // Find a matching original line by description
    const matchedOriginal = originalLines.find(
      oLine => oLine?.lineDescription === coLine?.lineDescription
    );

    // If matched, add matchedSequenceNumber from original line
    if (matchedOriginal) {
      return {
        ...coLine,
        matchedSequenceNumber: matchedOriginal.sequenceNumber
      };
    }

    return coLine; // if no match, return as-is
  });


    
  }
};

export default filterApplicationChangeOrders;
